var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 128 128",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.694,21.634l-14.9-3.2c-1.5-.323-3.008-.586-4.516-.817L76.964,8.25H89a1.75,1.75,0,0,0,0-3.5H39a1.75,1.75,0,0,0,0,3.5H51.036l1.683,9.368c-1.508.231-3.014.494-4.516.817l-14.9,3.2A13.821,13.821,0,0,0,22.442,35.077V94A13.758,13.758,0,0,0,34.11,107.571l-5.4,13.269a1.75,1.75,0,0,0,3.242,1.32l2.61-6.41H93.44l2.61,6.411a1.75,1.75,0,0,0,3.24-1.322l-5.4-13.268A13.759,13.759,0,0,0,105.558,94V35.077A13.821,13.821,0,0,0,94.694,21.634ZM54.593,8.25H73.407l-1.6,8.909a74.353,74.353,0,0,0-15.614,0Zm-18.608,104,1.834-4.5H90.182l1.833,4.5ZM102.058,94a10.261,10.261,0,0,1-10.25,10.25H36.192A10.261,10.261,0,0,1,25.942,94V35.077a10.3,10.3,0,0,1,8.1-10.021l14.9-3.2a71.264,71.264,0,0,1,30.125,0l14.9,3.2a10.3,10.3,0,0,1,8.1,10.021Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.81,34.447H33.19a1.75,1.75,0,0,0-1.75,1.75v26.05A1.75,1.75,0,0,0,33.19,64H94.81a1.75,1.75,0,0,0,1.75-1.75V36.2A1.75,1.75,0,0,0,94.81,34.447ZM93.06,60.5H34.94V37.947H93.06Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.876,73.5a9.75,9.75,0,1,0,9.75,9.75A9.761,9.761,0,0,0,84.876,73.5Zm0,16a6.25,6.25,0,1,1,6.25-6.25A6.257,6.257,0,0,1,84.876,89.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.124,73.5a9.75,9.75,0,1,0,9.75,9.75A9.761,9.761,0,0,0,43.124,73.5Zm0,16a6.25,6.25,0,1,1,6.25-6.25A6.257,6.257,0,0,1,43.124,89.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54,29.257H74a1.75,1.75,0,0,0,0-3.5H54a1.75,1.75,0,0,0,0,3.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTram);
export default __webpack_public_path__ + "static/media/tram.414d3722.svg";
export { ForwardRef as ReactComponent };